/****************************************************************************************
 * File Name    : SheetPatrol.vue
 * Function     :
 * Author       : 최명호
 * Tester       :
 * Page         :
 * Target       :
 * Description  :
 * Modification Log
 * ======================================================================================
 * Ver  Date        	Author     	Modification
 * ======================================================================================
   1.0  2021.04.16  	최명호    	Create
****************************************************************************************/
<template>
    <div>
        <a-row :gutter="16">
            <a-col class="gutter-row" :span="12">
                <div class="gutter-box">
                    <PageHeader title = "성적서 관리" />
                </div>
            </a-col>
        </a-row>
        <a-divider type = 'horizontal' />
        <a-form class="" layout = "vertical" >
            <a-card>
                <a-row>
                    <a-col :span="16">
                        <a-space align="end">
                            <!-- 성적서 조회
                            <a-input default-value="" v-model="filterCS" v-on:keyup="filterCSList">	
                                <a-select slot="addonAfter" default-value="부품코드" v-model="filterField" v-on:change="filterCSList">	
                                    <a-select-option value="부품코드">부품코드</a-select-option>	
                                    <a-select-option value="부품품명">부품품명</a-select-option>
                                    <a-select-option value="검사대상">검사대상</a-select-option>
                                </a-select>	
                            </a-input> -->

                            기간조회
                            <date-picker v-model="filterDateStartCS" valueType="format" v-on:change="filterCSList" style="width:120px;"></date-picker> ~
                            <date-picker v-model="filterDateEndCS" valueType="format" v-on:change="filterCSList" style="width:120px;"></date-picker>
                        </a-space>
                    </a-col>
                    <a-col :span="8">
                        <a-space style="float:right;">
                            <span class = 'icon_button' @click="showAdvancedSearch">	
                                <a-tag color="#1890FF" style="cursor:pointer;">	
                                    <a-icon type="search" /> 고급검색	
                                </a-tag>	
                            </span>
                            <span class = 'icon_button' @click="advancedExcelDownload()">	
                                <a-tag color="#6F42C1" style="cursor:pointer;">	
                                    <a-icon type="download" /> 다운로드(엑셀분석용)	
                                </a-tag>	
                            </span>
                            <span class = 'icon_button' @click="excelDownload()">	
                                <a-tag color="#28A745" style="cursor:pointer;">	
                                    <a-icon type="download" /> 엑셀 다운로드	
                                </a-tag>	
                            </span>
                        </a-space>
                    </a-col>
                </a-row>
                <p/>
                <a-table :columns="columns3" size = "small" :bordered=false :data-source="data3" :pagination="pagination" :scroll="{ x: 0, y: '80vh' }" @change="handleTableChange">
                    <span slot="tags" slot-scope="tags">
                        <a-tag v-for="tag in tags" :key="tag" class="state-btn" :class="{ green: (tag === '검사완료'), navy: (tag === '승인완료') }">
                            {{ tag.toUpperCase() }}
                        </a-tag>
                    </span>
                    <span slot="name" slot-scope="text">{{ text }}</span>
                    <span slot="action" slot-scope="record">
                        <span style = 'cursor:pointer' @click="handlerToViewProductCS(record.key, 'P')"><a-icon type="eye" /> View</span>	
                        <a-divider type="vertical" />	
                        <span style = 'cursor:pointer' @click="handlerToDeleteProductCS(record.key, 'P')"><a-icon type="delete" /> Delete</span>
                    </span>
                </a-table>
            </a-card>

        </a-form>
        <a-drawer title="" placement="right" :closable="false" :visible="flagForDrawer" @close="handlerForCloseDrawer" width="100%" >
            <FilterReportViewer :target = "target" :pop = "pop" :showSaveBtn = true :showConfirmBtn = true v-on:flagForDrawer="handlerForCloseDrawer" v-on:editFilterCS="handlerToEditFilterCS" />
        </a-drawer>

        <!-- 고급검색 모달 -->
        <a-modal 
            v-model="advancedSearchVisible" 
            title="고급검색"
            :width="600"
            :footer="null"
            :maskClosable="false"
            :destroyOnClose="true"
        >
            <template slot="title">
                <div style="display:flex; justify-content:space-between; align-items:center;">
                    <span>고급검색</span>
                    <div style="display:flex; gap:10px;">
                        <a-icon type="pushpin" :theme="isPinned ? 'filled' : 'outlined'" @click="togglePin" style="cursor:pointer; font-size:16px;" :title="isPinned ? '고정 해제' : '고정'" />
                        <a-icon type="fullscreen" @click="toggleFullscreen" style="cursor:pointer; font-size:16px;" title="확대" />
                    </div>
                </div>
            </template>

            <a-form layout="vertical">
                <!-- 기본 검색 조건 -->
                <a-row :gutter="16">
                    <a-col :span="12">
                        <a-form-item>
                            <a-checkbox v-model="advSearch.useDate">검사일자</a-checkbox>
                            <date-picker 
                                v-if="advSearch.useDate"
                                v-model="advSearch.dateStart" 
                                valueType="format" 
                                placeholder="시작일"
                                style="width:100%; margin-top:5px;"
                            />
                        </a-form-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-item>
                            <a-checkbox v-model="advSearch.useDateEnd" style="visibility:hidden;">종료일</a-checkbox>
                            <date-picker 
                                v-if="advSearch.useDate"
                                v-model="advSearch.dateEnd" 
                                valueType="format" 
                                placeholder="종료일"
                                style="width:100%; margin-top:5px;"
                            />
                        </a-form-item>
                    </a-col>
                </a-row>

                <a-row :gutter="16">
                    <a-col :span="8">
                        <a-form-item>
                            <a-checkbox v-model="advSearch.useLine">검사라인</a-checkbox>
                            <a-select 
                                v-if="advSearch.useLine"
                                v-model="advSearch.line" 
                                placeholder="원자재"
                                style="width:100%; margin-top:5px;"
                            >
                                <a-select-option value="원자재">원자재</a-select-option>
                                <a-select-option value="1호기">1호기</a-select-option>
                                <a-select-option value="2호기">2호기</a-select-option>
                                <a-select-option value="3호기">3호기</a-select-option>
                            </a-select>
                        </a-form-item>
                    </a-col>
                    <a-col :span="8">
                        <a-form-item>
                            <a-checkbox v-model="advSearch.useLotNo">Lot No.</a-checkbox>
                            <a-input 
                                v-if="advSearch.useLotNo"
                                v-model="advSearch.lotNo" 
                                placeholder="입력"
                                style="margin-top:5px;"
                            />
                        </a-form-item>
                    </a-col>
                    <a-col :span="8">
                        <a-form-item>
                            <a-checkbox v-model="advSearch.useManager">검사자</a-checkbox>
                            <a-input 
                                v-if="advSearch.useManager"
                                v-model="advSearch.manager" 
                                placeholder="입력"
                                style="margin-top:5px;"
                            />
                        </a-form-item>
                    </a-col>
                </a-row>

                <!-- 세부검색 필터 (접을 수 있음) -->
                <a-collapse v-model="activeCollapse" style="margin-top:10px;">
                    <a-collapse-panel key="1" header="세부검색 필터">
                        <a-row :gutter="16">
                            <a-col :span="8">
                                <a-form-item label="검사대상">
                                    <a-select v-model="advSearch.category" placeholder="원자재">
                                        <a-select-option value="">전체</a-select-option>
                                        <a-select-option value="원자재">원자재</a-select-option>
                                        <a-select-option value="카본블록">카본블록</a-select-option>
                                        <a-select-option value="엘리먼트">엘리먼트</a-select-option>
                                        <a-select-option value="필터">필터</a-select-option>
                                    </a-select>
                                </a-form-item>
                            </a-col>
                            <a-col :span="8">
                                <a-form-item>
                                    <a-checkbox v-model="advSearch.usePartCode">부품코드</a-checkbox>
                                    <a-input 
                                        v-if="advSearch.usePartCode"
                                        v-model="advSearch.partCode" 
                                        placeholder="120366"
                                        style="margin-top:5px;"
                                    />
                                </a-form-item>
                            </a-col>
                            <a-col :span="8">
                                <a-form-item label="부품명">
                                    <a-input 
                                        v-model="advSearch.partName" 
                                        placeholder="HOUSING-COMMON FILTER 1..."
                                        suffix-icon="search"
                                    >
                                        <a-icon slot="suffix" type="search" style="cursor:pointer;" @click="lookupPartName" />
                                    </a-input>
                                </a-form-item>
                            </a-col>
                        </a-row>

                        <a-row :gutter="16">
                            <a-col :span="8">
                                <a-form-item label="외관">
                                    <a-select v-model="advSearch.appearance" placeholder="OK">
                                        <a-select-option value="">전체</a-select-option>
                                        <a-select-option value="OK">OK</a-select-option>
                                        <a-select-option value="NG">NG</a-select-option>
                                    </a-select>
                                </a-form-item>
                            </a-col>
                            <a-col :span="8">
                                <a-form-item label="성능">
                                    <a-select v-model="advSearch.performance" placeholder="OK">
                                        <a-select-option value="">전체</a-select-option>
                                        <a-select-option value="OK">OK</a-select-option>
                                        <a-select-option value="NG">NG</a-select-option>
                                    </a-select>
                                </a-form-item>
                            </a-col>
                            <a-col :span="8">
                                <a-form-item label="무게">
                                    <a-input-group compact>
                                        <a-select v-model="advSearch.weightOperator" style="width:35%;">
                                            <a-select-option value=">=">&gt;=</a-select-option>
                                            <a-select-option value="<=">&lt;=</a-select-option>
                                            <a-select-option value="=">=</a-select-option>
                                        </a-select>
                                        <a-input v-model="advSearch.weight" placeholder="40" style="width:65%;" />
                                    </a-input-group>
                                </a-form-item>
                            </a-col>
                        </a-row>

                        <!-- 치수 필드들 -->
                        <a-form-item label="치수">
                            <a-row :gutter="8">
                                <a-col :span="4" style="text-align:center; line-height:32px;">A</a-col>
                                <a-col :span="4">
                                    <a-select v-model="advSearch.dimAOperator">
                                        <a-select-option value=">=">&gt;=</a-select-option>
                                        <a-select-option value="<=">&lt;=</a-select-option>
                                        <a-select-option value="=">=</a-select-option>
                                    </a-select>
                                </a-col>
                                <a-col :span="4">
                                    <a-input v-model="advSearch.dimA" />
                                </a-col>

                                <a-col :span="4" style="text-align:center; line-height:32px;">B</a-col>
                                <a-col :span="4">
                                    <a-select v-model="advSearch.dimBOperator">
                                        <a-select-option value=">=">&gt;=</a-select-option>
                                        <a-select-option value="<=">&lt;=</a-select-option>
                                        <a-select-option value="=">=</a-select-option>
                                    </a-select>
                                </a-col>
                                <a-col :span="4">
                                    <a-input v-model="advSearch.dimB" />
                                </a-col>
                            </a-row>
                        </a-form-item>

                        <a-form-item>
                            <a-row :gutter="8">
                                <a-col :span="4" style="text-align:center; line-height:32px;">C</a-col>
                                <a-col :span="4">
                                    <a-select v-model="advSearch.dimCOperator">
                                        <a-select-option value=">=">&gt;=</a-select-option>
                                        <a-select-option value="<=">&lt;=</a-select-option>
                                        <a-select-option value="=">=</a-select-option>
                                    </a-select>
                                </a-col>
                                <a-col :span="4">
                                    <a-input v-model="advSearch.dimC" />
                                </a-col>

                                <a-col :span="4" style="text-align:center; line-height:32px;">D</a-col>
                                <a-col :span="4">
                                    <a-select v-model="advSearch.dimDOperator">
                                        <a-select-option value=">=">&gt;=</a-select-option>
                                        <a-select-option value="<=">&lt;=</a-select-option>
                                        <a-select-option value="=">=</a-select-option>
                                    </a-select>
                                </a-col>
                                <a-col :span="4">
                                    <a-input v-model="advSearch.dimD" />
                                </a-col>
                            </a-row>
                        </a-form-item>

                        <a-form-item>
                            <a-row :gutter="8">
                                <a-col :span="4" style="text-align:center; line-height:32px;">E</a-col>
                                <a-col :span="4">
                                    <a-select v-model="advSearch.dimEOperator">
                                        <a-select-option value=">=">&gt;=</a-select-option>
                                        <a-select-option value="<=">&lt;=</a-select-option>
                                        <a-select-option value="=">=</a-select-option>
                                    </a-select>
                                </a-col>
                                <a-col :span="4">
                                    <a-input v-model="advSearch.dimE" />
                                </a-col>
                            </a-row>
                        </a-form-item>
                    </a-collapse-panel>
                </a-collapse>

                <!-- 검색 버튼 -->
                <div style="text-align:center; margin-top:20px;">
                    <a-button type="primary" @click="executeAdvancedSearch" size="large">
                        검색하기
                    </a-button>
                </div>
            </a-form>
        </a-modal>
    </div>
</template>
<script>
import _ from "lodash";
import DatePicker from 'vue2-datepicker';
import ExcelJS from "exceljs/dist/exceljs";
import PageHeader from "../components/PageHeader.vue";
import FilterReportViewer from "./FilterReportViewer.vue" ;

const userAgent = navigator.userAgent.toLowerCase();
const isTablet = /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|samsungbrowser|(puffin(?!.*(IP|AP|WP))))/.test(userAgent);

const columns = [
    {    title: '상태'    ,   dataIndex: 'tags' ,   key: 'tags'     ,  scopedSlots: { customRender: 'tags'        },  width : 100},
    {    title: '모델명' , dataIndex: 'model' , key: 'model' , scopedSlots: { customRender: 'model' },},
    {    title: '세부모델명' , dataIndex: 'modelDetail' , key: 'modelDetail' , scopedSlots: { customRender: 'modelDetail' },},
    {    title: '제품명' , dataIndex: 'product' , key: 'product' , scopedSlots: { customRender: 'name' },},
    {    title: 'POP' , dataIndex: 'pop' , key: 'pop' , scopedSlots: { customRender: 'pop' },},
    {    title: '라인' , dataIndex: 'line' , key: 'line' , scopedSlots: { customRender: 'name' },},
    {    title: '최종수정일',  dataIndex: 'updated', key: 'updated'  ,  scopedSlots: { customRender: 'updated'     },},
    {    title: '관리'                          ,   key: 'action'   ,  scopedSlots: { customRender: 'action'      },  width : 250},
];
const columns2 = [
    {    title: '관리'                          ,   key: 'action'   ,  scopedSlots: { customRender: 'action'      },  width : 100},	
    {    title: '상태'    ,   dataIndex: 'tags' ,   key: 'tags'     ,  scopedSlots: { customRender: 'tags'        },  width : 100},	
    {    title: '이름'    ,   dataIndex: 'name' ,   key: 'name'     ,  scopedSlots: { customRender: 'name'        },},
];
let columns3 = [
    {    title: '상태'    ,   dataIndex: 'tags' ,   key: 'tags'     ,  scopedSlots: { customRender: 'tags'        },  width : 100},
    {    title: '검사대상' , dataIndex: 'category' , key: 'category' , scopedSlots: { customRender: 'category' }, width : 100},
    {    title: '부품코드' , dataIndex: 'partCode' , key: 'partCode' , scopedSlots: { customRender: 'partCode' }, width : 150},
    {    title: '부품품명' , dataIndex: 'partName' , key: 'partName' , scopedSlots: { customRender: 'partName' },},
    {    title: '라인' , dataIndex: 'line' , key: 'line' , scopedSlots: { customRender: 'line' }, width : 100},
    {    title: 'LOT' , dataIndex: 'barcode' , key: 'barcode' , scopedSlots: { customRender: 'barcode' }, width : 100},
    {    title: '결과',  dataIndex: 'checkState', key: 'checkState'  ,  scopedSlots: { customRender: 'updated'     }, width : 80},
    {    title: '최종수정일',  dataIndex: 'updated', key: 'updated'  ,  scopedSlots: { customRender: 'updated'     }, width : 180},
    {    title: '관리'                          ,   key: 'action'   ,  scopedSlots: { customRender: 'action'      },  width : 200},
];
if (isTablet) {
    columns3 = [
        {    title: '상태'    ,   dataIndex: 'tags' ,   key: 'tags'     ,  scopedSlots: { customRender: 'tags'        },  width : 100},
        {    title: '검사대상' , dataIndex: 'category' , key: 'category' , scopedSlots: { customRender: 'category' }, width : 80},
        {    title: '부품코드' , dataIndex: 'partCode' , key: 'partCode' , scopedSlots: { customRender: 'partCode' }, width : 80},
        {    title: '부품품명' , dataIndex: 'partName' , key: 'partName' , scopedSlots: { customRender: 'partName' },},
        {    title: '라인' , dataIndex: 'line' , key: 'line' , scopedSlots: { customRender: 'line' }, width : 100},
        {    title: 'LOT' , dataIndex: 'barcode' , key: 'barcode' , scopedSlots: { customRender: 'barcode' }, width : 100},
        {    title: '결과',  dataIndex: 'checkState', key: 'checkState'  ,  scopedSlots: { customRender: 'updated'     }, width : 80},
        {    title: '최종수정일',  dataIndex: 'updated', key: 'updated'  ,  scopedSlots: { customRender: 'updated'     }, width : 180},
        {    title: '관리'                          ,   key: 'action'   ,  scopedSlots: { customRender: 'action'      },  width : 80},
    ];
}

const data = [
  {    key: '1',    name: 'FGCS210505-WP400-V1 보류중 20200401-15:30'   ,  tags: ['필요'],  },
  {    key: '2',    name: 'FGCS210505-WP301-V1 보류중 20200329-09:30'   ,  tags: ['필요'],  },
  {    key: '3',    name: 'PCCS210505-WP400-V1 완료 20200401-15:30'     ,  tags: ['진행'],  },
  {    key: '4',    name: 'PCCS210505-WP301-V1 완료 20200329-09:30'     ,  tags: ['완료'],  },
];

export default {
    name: 'FilterReport',
    components: {
        PageHeader ,
        DatePicker,
        FilterReportViewer,
    },
    data() {
        return {
            isDataLoaded : false,
            flagForDrawer: false,
            flagSpinner: false,
            data,
            columns,
            columns2,
            columns3,
            data3: [],
            data3Backup: [],	
            dataArray3: [],	
            pop: null,	
            target: null,	
            filterCS : '',	
            filterField: '부품코드',
            filterDateStartCS: '',
            filterDateEndCS: '',
            pagination: {
                current: 1,
                pageSize: 10,
                total: 0,
                showSizeChanger: true,
                showTotal: (total, range) => `${range[0]}-${range[1]} / ${total}개`
            },
            // 고급검색 관련 데이터
            advancedSearchVisible: false,
            advancedSearchMode: false,
            advancedSearchBaseUrl: '',
            isPinned: false,
            activeCollapse: [],
            advSearch: {
                useDate: false,
                dateStart: '',
                dateEnd: '',
                useDateEnd: false,
                useLine: false,
                line: '',
                useLotNo: false,
                lotNo: '',
                useManager: false,
                manager: '',
                category: '',
                usePartCode: false,
                partCode: '',
                partName: '',
                appearance: '',
                performance: '',
                weightOperator: '>=',
                weight: '',
                dimAOperator: '>=',
                dimA: '',
                dimBOperator: '>=',
                dimB: '',
                dimCOperator: '>=',
                dimC: '',
                dimDOperator: '>=',
                dimD: '',
                dimEOperator: '>=',
                dimE: ''
            }
        };
    },
    mounted() {
        this.pop = sessionStorage.getItem('filter_pop') || '';
        
        this.isDataLoaded = true;
        this.fetchProductCSList();

        if (isTablet) {
            let x;
            let els1 = document.body.querySelectorAll('.ant-layout-header');
            for (x = 0; x < els1.length; x++) {
                els1[x].style.display = 'none';
            }
            let els2 = document.body.querySelectorAll('.ant-breadcrumb');
            for (x = 0; x < els2.length; x++) {
                els2[x].style.display = 'none';
            }
            let els3 = document.body.querySelectorAll('.ant-divider-horizontal');
            for (x = 0; x < els3.length; x++) {
                els3[x].style.display = 'none';
            }
            let els4 = document.body.querySelectorAll('.desktop-only');
            for (x = 0; x < els4.length; x++) {
                els4[x].style.display = 'none';
            }
            let els5 = document.body.querySelectorAll('.ant-layout-sider');
            for (x = 0; x < els5.length; x++) {
                els5[x].style.display = 'none';
            }
        }
    },
    methods : {
        fetchProductCSList(skipBarcodeScan, page = 1, pageSize = 10) {
            this.dataArray3 = [];
            this.data = [];
            this.data3 = [];
            this.flagSpinner = true;
            
            // 기존 페이징 방식으로 복원 (서버에서 정렬 처리)
            let urlToFetchProductCSList = `${this.$store.state.nodeApiUrl}/product/cs/list_filter?size=${pageSize}&page=${page-1}&state=P,R`;
            
            // 필터 조건 추가
            if (this.filterCS) {
                if (this.filterField === '부품코드') {
                    urlToFetchProductCSList += `&part_code=${this.filterCS}`;
                } else if (this.filterField === '부품품명') {
                    urlToFetchProductCSList += `&part_name=${this.filterCS}`;
                } else if (this.filterField === '검사대상') {
                    urlToFetchProductCSList += `&category=${this.filterCS}`;
                } else if (this.filterField === '검사결과') {
                    urlToFetchProductCSList += `&check_state=${this.filterCS.toUpperCase()}`;
                }
            }
            
            // 날짜 필터 추가
            if (this.filterDateStartCS) {
                urlToFetchProductCSList += `&start_date=${this.filterDateStartCS}`;
            }
            if (this.filterDateEndCS) {
                // 종료일에는 23:59:59 추가
                urlToFetchProductCSList += `&end_date=${this.filterDateEndCS} 23:59:59`;
            }
            
            this.$http.get(urlToFetchProductCSList)
            .then((response) => {
                if(response.status === 200 && response.data.code === 'success') {
                    // 서버에서 이미 정렬된 데이터 사용
                    const pageData = response.data.data.content;
                    
                    // 페이지네이션 정보 업데이트
                    this.pagination.total = response.data.data.totalElements;
                    this.pagination.current = page;
                    this.pagination.pageSize = pageSize;
                    
                    this.dataArray3 = pageData;
                    
                    // 데이터 처리
                    this.processData();
                }
                this.flagSpinner = false;
            }).catch(error => {
                console.log(error);
                this.flagSpinner = false;
            });
        },
        
        processData() {
            // 기존 데이터 처리 로직
            _.forEach(this.dataArray3, function(item) {
                _.forEach(item.listProductCSInpection, function(item2) {
                    if (item2.listProductCSInpectionStandard.length === 1 && item2.listProductCSInpectionStandard[0].min === '') {
                        for (var i = 0; i < 14; i++) {
                            item2.listProductCSInpectionStandard.push(JSON.parse(JSON.stringify(item2.listProductCSInpectionStandard[0])));
                        }
                    } else if (item2.listProductCSInpectionStandard.length === 1) {
                        let min = item2.listProductCSInpectionStandard[0].min.split('||'),
                            max = item2.listProductCSInpectionStandard[0].max.split('||'),
                            name = item2.listProductCSInpectionStandard[0].name.split('||'),
                            result = item2.listProductCSInpectionStandard[0].result.split('||'),
                            obj = JSON.parse(JSON.stringify(item2.listProductCSInpectionStandard[0]));
                        for (var j = 0; j < 15; j++) {
                            obj.min = min[j];
                            obj.max = max[j];
                            obj.name = name[j];
                            obj.result = result[j];
                            item2.listProductCSInpectionStandard[j] = JSON.parse(JSON.stringify(obj));
                        }
                    }
                })
            });
            
            // 검사완료, 승인완료 정렬 : 검사완료, 승인완료 순으로, 검사완료는 과거 데이터가 먼저 나오도록
            let tempArr1 = _.filter(this.dataArray3, {
                state: 'P'
            });
            tempArr1 = _.orderBy(tempArr1, ['updated'], ['desc']);  // 수정 날짜 최신순 정렬
            let tempArr2 = _.filter(this.dataArray3, {
                state: 'R'
            });
            tempArr2 = _.orderBy(tempArr2, ['updated'], ['desc']);  // 수정 날짜 최신순 정렬
            this.dataArray3 = tempArr1.concat(tempArr2);
            
            let data3 = [];
            
            for(let x = 0; x < this.dataArray3.length ; x ++) {
                // 날짜 형식 변환
                let updatedObj = new Date((new Date(this.dataArray3[x].updated)).getTime() + 0 * 60 * 60 * 1000);
                let year = updatedObj.getFullYear();
                let month = (updatedObj.getMonth() + 1).toString().padStart(2, '0');
                let date = updatedObj.getDate().toString().padStart(2, '0');
                let hour = updatedObj.getHours().toString().padStart(2, '0');
                let minute = updatedObj.getMinutes().toString().padStart(2, '0');
                let second = updatedObj.getSeconds().toString().padStart(2, '0');
                
                let checkState = 'PASS';
                if (this.dataArray3[x].csTime === 'FAIL') {
                    checkState = 'FAIL';
                }
                
                data3.push({
                    key : x,
                    name : this.dataArray3[x].name,
                    pop : this.dataArray3[x].clsProduct.productPop,
                    tags : (this.dataArray3[x].state === 'P' ? ['검사완료'] : ['승인완료']),
                    updated : `${year}-${month}-${date} ${hour}:${minute}:${second}`,
                    model : this.dataArray3[x].clsProduct.productModel,
                    modelDetail : this.dataArray3[x].clsProduct.productModelDetail,
                    product : this.dataArray3[x].clsProduct.productName,
                    manager: this.dataArray3[x].manager,
                    line : this.dataArray3[x].line,
                    barcode : this.dataArray3[x].barcode,
                    checkState: checkState,
                    category : this.dataArray3[x].category,
                    partName : this.dataArray3[x].partName,
                    partCode : this.dataArray3[x].partCode,
                    image1 : this.dataArray3[x].image1,
                    image2 : this.dataArray3[x].image2,
                    productCsSeq: this.dataArray3[x].productCsSeq,
                });
            }
            
            this.data3 = data3;
            this.data3Backup = JSON.parse(JSON.stringify(this.data3));
        },
        handlerToViewProductCS(dataOffset) {
            this.dataOffset = dataOffset;
            let target = this.dataArray3[dataOffset];

            let urlToFetchProductCSList = this.$store.state.nodeApiUrl + "/product/cs/get_filter_cs_item?seq=" + target.productCsSeq;
                this.$http.get(urlToFetchProductCSList)
                .then((response) => {
                    if(response.status === 200 && response.data.code === 'success') {
                        let item = response.data.data.content[0];
                        this.target = item;

                        _.forEach(item.listProductCSInpection, function(item2) {
                            if (item2.listProductCSInpectionStandard.length === 1 && item2.listProductCSInpectionStandard[0].min === '') {
                                for (var i = 0; i < 14; i++) {
                                    item2.listProductCSInpectionStandard.push(JSON.parse(JSON.stringify(item2.listProductCSInpectionStandard[0])));
                                }
                            } else if (item2.listProductCSInpectionStandard.length === 1) {
                                let min = item2.listProductCSInpectionStandard[0].min.split('||'),
                                    max = item2.listProductCSInpectionStandard[0].max.split('||'),
                                    name = item2.listProductCSInpectionStandard[0].name.split('||'),
                                    result = item2.listProductCSInpectionStandard[0].result.split('||'),
                                    obj = JSON.parse(JSON.stringify(item2.listProductCSInpectionStandard[0]));
                                for (var j = 0; j < 15; j++) {
                                    obj.min = min[j];
                                    obj.max = max[j];
                                    obj.name = name[j];
                                    obj.result = result[j];
                                    item2.listProductCSInpectionStandard[j] = JSON.parse(JSON.stringify(obj));
                                }
                            }
                        })

                        // TO DO - 서버에서 수정한 후 이 코드 삭제 - updated 가 9 시간이 작게 나와서 프론트엔드에서 수정
                        let updatedObj = new Date((new Date(this.target.updated)).getTime() + 0 * 60 * 60 * 1000);
                        let year = updatedObj.getFullYear();
                        let month = updatedObj.getMonth() + 1;
                        if (month < 10) {
                            month = '0' + month;
                        }
                        let date = updatedObj.getDate();
                        if (date < 10) {
                            date = '0' + date;
                        }
                        let hour = updatedObj.getHours();
                        if (hour < 10) {
                            hour = '0' + hour;
                        }
                        let minute = updatedObj.getMinutes();
                        if (minute < 10) {
                            minute = '0' + minute;
                        }
                        let second = updatedObj.getSeconds();
                        if (second < 10) {
                            second = '0' + second;
                        }
                        this.target.updated = year + '-' + month + '-' + date + ' ' + hour + ':' + minute + ':' + second;

                        this.flagForDrawer = true;
                    }
                });
        },
        handlerToEditFilterCS(listItem, state) {
            let generatedObjectToPersist = {
                productCsSeq: listItem.productCsSeq,
                productSeq: listItem.clsProduct.productSeq,
                productCSName: listItem.name,
                productCSInspections: [],
                productCSTimes: [],
                state: state,
                pop: listItem.pop,
                csTime: listItem.csTime,
                line: listItem.line,
                barcode: listItem.barcode,
                manager: listItem.manager,
                approver: (state === 'R' ? sessionStorage.getItem('user_name') : ''),
            };

            _.forEach(listItem.listProductCSInpection, (item) => {
                let min = [],
                    max = [],
                    name = [],
                    result = [];

                _.forEach(item.listProductCSInpectionStandard, function(item2) {
                    min.push(item2.min || '');
                    max.push(item2.max || '');
                    name.push(item2.name || '');
                    result.push(item2.result || '');
                });

                min = min.join('||');
                max = max.join('||');
                name = name.join('||');
                result = result.join('||');

                let obj = {
                    index: '' + item.inspectionIndex,
                    offset: '' + item.inspectionOffset,
                    inspection: item.inspectionName,
                    inspectionTarget: item.inspectionTarget || '',
                    standard: {
                        min: min,
                        max: max,
                        name: name,
                        result: result
                    },
                    imageSeq: item.inspectionImageSeq,
                    image2Seq: item.inspectionImage2Seq,
                    description: item.inspectionDescription
                };

                generatedObjectToPersist.productCSInspections.push(obj);
            });

            _.forEach(listItem.listProductCSTime, (item) => {
                let obj = {
                    start: item.timeStart,
                    terms: item.timeTerms
                };

                generatedObjectToPersist.productCSTimes.push(obj);
            });


            let urlForProduct = this.$store.state.hostInService + '/product/cs/edit';
            this.$http.put(urlForProduct,generatedObjectToPersist)
            .then((response) => {
                if (response.status === 200 && response.data.code === 'success') {
                    this.$message.success('저장되었습니다');
                    
                    // 현재 페이지를 유지하면서 목록의 상태만 업데이트
                    this.updateItemStateInCurrentList();
                    
                    // 레이어 닫기
                    this.flagForDrawer = false;
                }  else {
                    this.$message.error('저장되지 않았습니다(1).');
                }
            })
            .catch(error => {
                console.error(error);
                this.$message.error('저장되지 않았습니다(2).');
            });
        },
        
        updateItemStateInCurrentList() {
            // 상태 변경 후 전체 데이터 재정렬이 필요하므로 새로 데이터를 가져옴
            // 현재 페이지는 유지하면서 올바른 정렬된 데이터를 표시
            this.refreshCurrentPageData();
        },
        
        refreshCurrentPageData() {
            // 현재 페이지와 페이지 사이즈 유지하면서 데이터 갱신
            this.fetchProductCSList(false, this.pagination.current, this.pagination.pageSize);
        },
        handlerForCloseDrawer() {
            this.flagForDrawer = false;
        },
        handlerToDeleteProductCS(dataOffset) {
            this.target = this.dataArray3[dataOffset];

            if (confirm('삭제하시겠습니까?')) {
                let urlForProduct = this.$store.state.hostInService + '/product/cs/delete';
                let listItem = this.target;
                let generatedObjectToPersist = {
                    productCsSeq: listItem.productCsSeq
                };
                this.$http.put(urlForProduct,generatedObjectToPersist)
                    .then((response) => {
                        if (response.status === 200 && response.data.code === 'success') {
                            this.$message.success('삭제되었습니다');
                            
                            // 현재 페이지와 검색 조건을 유지하면서 목록 갱신
                            this.refreshCurrentPageData();
                        }  else {
                            this.$message.error('삭제되지 않았습니다(1).');
                        }
                    })
                    .catch(error => {
                        console.error(error);
                        this.$message.error('삭제되지 않았습니다(2).');
                    });
            }
        },
        handlerToCreateCSForFilterPop() {
            if (!this.pop) {
                this.$message.error('POP를 입력해주세요');
                return;
            }
            
            let pop = this.pop;
            if (pop) {
                sessionStorage.setItem('filter_pop', pop);
                location.reload();
            } else {
                this.$message.error('인식된 POP의 제품이 등록되어 있지 않습니다.');
            }
        },
        handlerToCreateCSForFilter(listItem) {

            let generatedObjectToPersist = {
                productSeq: listItem.clsProduct.productSeq,
                productCSName: 'FILTERCS-' + listItem.name,
                productCSInspections: [],
                productCSTimes: [],
                state: 'O',
                pop: this.pop,
                csTime: ''
            };

            _.forEach(listItem.listProductCSInpection, (item) => {
                let obj = {
                    index: '' + item.inspectionIndex,
                    offset: '' + item.inspectionOffset,
                    inspection: item.inspectionName,
                    inspectionTarget: item.inspectionTarget || '',
                    standard: {
                        min: item.listProductCSInpectionStandard.length && item.listProductCSInpectionStandard[0].min || '',
                        max: item.listProductCSInpectionStandard.length && item.listProductCSInpectionStandard[0].max || '',
                        name: item.listProductCSInpectionStandard.length && item.listProductCSInpectionStandard[0].name || '',
                        result: item.listProductCSInpectionStandard.length && item.listProductCSInpectionStandard[0].result || ''
                    },
                    imageSeq: item.inspectionImageSeq,
                    image2Seq: 0,
                    description: item.inspectionDescription
                };

                generatedObjectToPersist.productCSInspections.push(obj);
            });

            _.forEach(listItem.listProductCSTime, (item) => {
                let obj = {
                    start: item.timeStart,
                    terms: item.timeTerms
                };

                generatedObjectToPersist.productCSTimes.push(obj);
            });


            let urlForProduct = this.$store.state.hostInService + '/product/cs/add';
            this.$http.post(urlForProduct,generatedObjectToPersist)
            .then((response) => {
                if (response.status === 200 && response.data.code === 'success') {
                    this.$message.success('생성되었습니다');
                    this.fetchProductCSList(true, true);
                    this.pop = '';
                    sessionStorage.removeItem('filter_pop');
                }  else {
                    this.$message.error('생성되지 않았습니다(1).');
                }
            })
            .catch(error => {
                console.error(error);
                this.$message.error('생성되지 않았습니다(2).');
            });
        },
        filterCSList() {
            this.advancedSearchMode = false;
            this.advancedSearchBaseUrl = '';
            this.pagination.current = 1;
            this.fetchProductCSList(false, 1, this.pagination.pageSize);
        },
        
        handleTableChange(pagination) {
            if (this.advancedSearchMode) {
                this.fetchAdvancedSearchPage(pagination.current, pagination.pageSize);
            } else {
                this.fetchProductCSList(false, pagination.current, pagination.pageSize);
            }
        },
        fetchAdvancedSearchPage(page, pageSize) {
            const apiUrl = this.advancedSearchBaseUrl
                + `&size=${pageSize}&page=${page - 1}`;
            this.flagSpinner = true;
            this.$http.get(apiUrl)
                .then((response) => {
                    if (response.status === 200 && response.data.code === 'success') {
                        this.pagination.total = response.data.data.totalElements || 0;
                        this.pagination.current = page;
                        this.pagination.pageSize = pageSize;

                        this.dataArray3 = response.data.data.content;
                        this.data3 = this.dataArray3.map((item, index) => {
                            let tag = item.state === 'P' ? '검사완료' : '승인완료';
                            let checkState = item.csTime === 'FAIL' ? 'FAIL' : 'PASS';
                            let updatedObj = new Date(item.updated);
                            let year = updatedObj.getFullYear();
                            let month = (updatedObj.getMonth() + 1).toString().padStart(2, '0');
                            let date = updatedObj.getDate().toString().padStart(2, '0');
                            let hour = updatedObj.getHours().toString().padStart(2, '0');
                            let minute = updatedObj.getMinutes().toString().padStart(2, '0');
                            let second = updatedObj.getSeconds().toString().padStart(2, '0');
                            return {
                                key: index,
                                productCsSeq: item.productCsSeq,
                                tags: [tag],
                                model: item.productModel || '-',
                                modelDetail: item.productModelDetail || '-',
                                product: item.productName || '-',
                                pop: item.productPop || '-',
                                line: item.line || '-',
                                barcode: item.barcode || '-',
                                manager: item.manager || '-',
                                checkState: checkState,
                                category: item.category || '-',
                                partCode: item.partCode || '-',
                                partName: item.partName || '-',
                                updated: `${year}-${month}-${date} ${hour}:${minute}:${second}`,
                            };
                        });
                    }
                    this.flagSpinner = false;
                })
                .catch((error) => {
                    console.error(error);
                    this.flagSpinner = false;
                });
        },
        advancedExcelDownload() {
            this.flagSpinner = true;

            let urlToFetchAllData = `${this.$store.state.nodeApiUrl}/product/cs/list_filter?size=10000&page=0&state=P,R`;

            if (this.filterCS) {
                if (this.filterField === '부품코드') {
                    urlToFetchAllData += `&part_code=${this.filterCS}`;
                } else if (this.filterField === '부품품명') {
                    urlToFetchAllData += `&part_name=${this.filterCS}`;
                } else if (this.filterField === '검사대상') {
                    urlToFetchAllData += `&category=${this.filterCS}`;
                } else if (this.filterField === '검사결과') {
                    urlToFetchAllData += `&check_state=${this.filterCS.toUpperCase()}`;
                }
            }
            if (this.filterDateStartCS) {
                urlToFetchAllData += `&start_date=${this.filterDateStartCS}`;
            }
            if (this.filterDateEndCS) {
                urlToFetchAllData += `&end_date=${this.filterDateEndCS} 23:59:59`;
            }

            this.$http.get(urlToFetchAllData)
            .then((response) => {
                if (response.status === 200 && response.data.code === 'success') {
                    let dataArray3 = response.data.data.content;

                    // 검사기준 데이터 정규화 (기존과 동일)
                    _.forEach(dataArray3, function(item) {
                        _.forEach(item.listProductCSInpection, function(item2) {
                            if (item2.listProductCSInpectionStandard.length === 1 && item2.listProductCSInpectionStandard[0].min === '') {
                                for (var i = 0; i < 14; i++) {
                                    item2.listProductCSInpectionStandard.push(JSON.parse(JSON.stringify(item2.listProductCSInpectionStandard[0])));
                                }
                            } else if (item2.listProductCSInpectionStandard.length === 1) {
                                let min    = item2.listProductCSInpectionStandard[0].min.split('||'),
                                    max    = item2.listProductCSInpectionStandard[0].max.split('||'),
                                    name   = item2.listProductCSInpectionStandard[0].name.split('||'),
                                    result = item2.listProductCSInpectionStandard[0].result.split('||'),
                                    obj    = JSON.parse(JSON.stringify(item2.listProductCSInpectionStandard[0]));
                                for (var j = 0; j < 15; j++) {
                                    obj.min    = min[j];
                                    obj.max    = max[j];
                                    obj.name   = name[j];
                                    obj.result = result[j];
                                    item2.listProductCSInpectionStandard[j] = JSON.parse(JSON.stringify(obj));
                                }
                            }
                        });
                    });

                    // 정렬 (검사완료 P → 승인완료 R, 각각 updated 내림차순)
                    let tempArr1 = _.orderBy(_.filter(dataArray3, { state: 'P' }), ['updated'], ['desc']);
                    let tempArr2 = _.orderBy(_.filter(dataArray3, { state: 'R' }), ['updated'], ['desc']);
                    dataArray3 = tempArr1.concat(tempArr2);

                    // 날짜 포맷 및 결과값 설정
                    _.forEach(dataArray3, function(item) {
                        item.checkState = (item.csTime === 'FAIL') ? 'FAIL' : 'PASS';
                        let d = new Date(item.updated);
                        item.formattedDate = `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')} ${String(d.getHours()).padStart(2,'0')}:${String(d.getMinutes()).padStart(2,'0')}:${String(d.getSeconds()).padStart(2,'0')}`;
                    });

                    // VBA WriteHeader 와 동일한 19컬럼 헤더
                    const HEADERS = ['검사일자','검사라인','검사자명','검사대상','부품코드','부품품명','LOT No.','결과','분류','항목','규격','측정기기','X1','X2','X3','X4','X5','평균','판정'];

                    // VBA LoadOneSheetToResult 와 동일한 평탄화 로직
                    let flatRows = [];
                    _.forEach(dataArray3, function(item) {
                        let sortedInspections = _.sortBy(item.listProductCSInpection, ['inspectionIndex', 'inspectionOffset']);
                        _.forEach(sortedInspections, function(item2) {
                            let resultArr = [];
                            _.forEach(item2.listProductCSInpectionStandard, function(item3, i) {
                                if (i < 5) {
                                    resultArr.push((item2.listProductCSInpectionStandard[7] && item2.listProductCSInpectionStandard[7].min) ? item3.max : item3.min);
                                }
                                if (i === 5) {
                                    resultArr.push((item2.listProductCSInpectionStandard[7] && item2.listProductCSInpectionStandard[7].min) ? item3.max : '');
                                }
                                if (i === 6) {
                                    resultArr.push(item3.max);
                                }
                            });

                            flatRows.push({
                                row: [
                                    item.formattedDate || item.updated,
                                    item.line,
                                    item.manager,
                                    item.category,
                                    item.partCode,
                                    item.partName,
                                    item.barcode,
                                    item.checkState,
                                    item2.inspectionTarget,
                                    item2.inspectionName,
                                    item2.listProductCSInpectionStandard[0] ? item2.listProductCSInpectionStandard[0].name   : '',
                                    item2.listProductCSInpectionStandard[0] ? item2.listProductCSInpectionStandard[0].result : '',
                                    ...resultArr
                                ],
                                partCode: item.partCode
                            });
                        });
                    });

                    // VBA FormatOne: 헤더 스타일 (진한 파란 배경 + 흰 글씨 + 굵게)
                    const applyHeaderStyle = (ws) => {
                        let headerRow = ws.getRow(1);
                        headerRow.font = { bold: true, color: { argb: 'FFFFFFFF' } };
                        headerRow.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF1F4E79' } };
                        headerRow.commit();
                    };

                    // VBA FormatOne: 판정(S=19번째) 컬럼 PASS/FAIL 색상
                    const applyJudgmentColor = (ws, rowIdx) => {
                        let cell = ws.getRow(rowIdx).getCell(19);
                        let val  = String(cell.value || '').toUpperCase().trim();
                        if (val === 'PASS' || val === 'OK') {
                            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE2EFDA' } };
                        } else if (val === 'FAIL' || val === 'NG') {
                            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFC7CE' } };
                        }
                    };

                    // VBA CleanName: 시트이름 불가 문자 제거, 25자 제한
                    const cleanName = (s) => {
                        s = String(s).replace(/[\\/:*?[\]]/g, '_');
                        return s.length > 25 ? s.substring(0, 25) : s;
                    };

                    // 워크북 생성
                    let workbook = new ExcelJS.Workbook();

                    // Result_All 시트 (VBA Result_All 과 동일)
                    let wsAll = workbook.addWorksheet('Result_All');
                    wsAll.addRow(HEADERS);

                    // Part_XXXXX 시트 맵
                    let partSheetMap = {};

                    flatRows.forEach(({ row, partCode }) => {
                        let addedRowAll = wsAll.addRow(row);
                        applyJudgmentColor(wsAll, addedRowAll.number);

                        let sheetName = 'Part_' + cleanName(partCode);
                        if (!partSheetMap[sheetName]) {
                            let wsPart = workbook.addWorksheet(sheetName);
                            wsPart.addRow(HEADERS);
                            partSheetMap[sheetName] = wsPart;
                        }
                        let addedRowPart = partSheetMap[sheetName].addRow(row);
                        applyJudgmentColor(partSheetMap[sheetName], addedRowPart.number);
                    });

                    // 모든 시트에 헤더 스타일 적용
                    applyHeaderStyle(wsAll);
                    Object.values(partSheetMap).forEach(ws => applyHeaderStyle(ws));

                    // 파일 다운로드
                    let dateObj = new Date();
                    let dateStr = `${dateObj.getFullYear()}${String(dateObj.getMonth()+1).padStart(2,'0')}${String(dateObj.getDate()).padStart(2,'0')}`;

                    workbook.xlsx.writeBuffer().then(function(data) {
                        let blob     = new Blob([data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                        let filename = '필터성적서(분석용)_' + dateStr + '.xlsx';
                        let reader   = new FileReader();
                        reader.readAsDataURL(blob);
                        reader.onload = function(event) {
                            let save = document.createElement("a");
                            save.href     = event.target.result;
                            save.download = filename;
                            document.body.appendChild(save);
                            save.click();
                            document.body.removeChild(save);
                            window.URL.revokeObjectURL(save.href);
                        };
                    });
                }
                this.flagSpinner = false;
            }).catch(error => {
                console.log(error);
                this.flagSpinner = false;
            });
        },
        excelDownload() {
            // Excel 파일로 저장하기 위해 전체 데이터를 다시 불러옵니다.
            this.flagSpinner = true;
            
            // 모든 데이터를 한번에 가져오기 위한 API 호출
            let urlToFetchAllData = `${this.$store.state.nodeApiUrl}/product/cs/list_filter?size=10000&page=0&state=P,R`;
            
            // 현재 필터 조건 추가
            if (this.filterCS) {
                if (this.filterField === '부품코드') {
                    urlToFetchAllData += `&part_code=${this.filterCS}`;
                } else if (this.filterField === '부품품명') {
                    urlToFetchAllData += `&part_name=${this.filterCS}`;
                } else if (this.filterField === '검사대상') {
                    urlToFetchAllData += `&category=${this.filterCS}`;
                } else if (this.filterField === '검사결과') {
                    urlToFetchAllData += `&check_state=${this.filterCS.toUpperCase()}`;
                }
            }
            
            // 날짜 필터 추가
            if (this.filterDateStartCS) {
                urlToFetchAllData += `&start_date=${this.filterDateStartCS}`;
            }
            if (this.filterDateEndCS) {
                urlToFetchAllData += `&end_date=${this.filterDateEndCS} 23:59:59`;
            }
            
            this.$http.get(urlToFetchAllData)
            .then((response) => {
                if(response.status === 200 && response.data.code === 'success') {
                    let allData = response.data.data.content;
                    
                    // 데이터 준비
                    let dataArray3 = allData;
                    
                    // 데이터 처리 - 원본 코드와 동일한 로직 적용
                    _.forEach(dataArray3, function(item) {
                        _.forEach(item.listProductCSInpection, function(item2) {
                            if (item2.listProductCSInpectionStandard.length === 1 && item2.listProductCSInpectionStandard[0].min === '') {
                                for (var i = 0; i < 14; i++) {
                                    item2.listProductCSInpectionStandard.push(JSON.parse(JSON.stringify(item2.listProductCSInpectionStandard[0])));
                                }
                            } else if (item2.listProductCSInpectionStandard.length === 1) {
                                let min = item2.listProductCSInpectionStandard[0].min.split('||'),
                                    max = item2.listProductCSInpectionStandard[0].max.split('||'),
                                    name = item2.listProductCSInpectionStandard[0].name.split('||'),
                                    result = item2.listProductCSInpectionStandard[0].result.split('||'),
                                    obj = JSON.parse(JSON.stringify(item2.listProductCSInpectionStandard[0]));
                                for (var j = 0; j < 15; j++) {
                                    obj.min = min[j];
                                    obj.max = max[j];
                                    obj.name = name[j];
                                    obj.result = result[j];
                                    item2.listProductCSInpectionStandard[j] = JSON.parse(JSON.stringify(obj));
                                }
                            }
                        });
                    });
                    
                    // 검사완료, 승인완료 정렬
                    let tempArr1 = _.filter(dataArray3, {
                        state: 'P'
                    });
                    tempArr1 = _.orderBy(tempArr1, ['updated'], ['desc']);
                    let tempArr2 = _.filter(dataArray3, {
                        state: 'R'
                    });
                    tempArr2 = _.orderBy(tempArr2, ['updated'], ['desc']);
                    dataArray3 = tempArr1.concat(tempArr2);
                    
                    // 데이터 가공 및 Excel 생성
                    let listData = [];
                    for(let x = 0; x < dataArray3.length; x++) {
                        // 결과값 설정
                        let checkState = 'PASS';
                        if (dataArray3[x].csTime === 'FAIL') {
                            checkState = 'FAIL';
                        }
                        
                        // 날짜 포맷팅
                        let updatedObj = new Date((new Date(dataArray3[x].updated)).getTime() + 0 * 60 * 60 * 1000);
                        let year = updatedObj.getFullYear();
                        let month = (updatedObj.getMonth() + 1).toString().padStart(2, '0');
                        let date = updatedObj.getDate().toString().padStart(2, '0');
                        let hour = updatedObj.getHours().toString().padStart(2, '0');
                        let minute = updatedObj.getMinutes().toString().padStart(2, '0');
                        let second = updatedObj.getSeconds().toString().padStart(2, '0');
                        let formattedDate = `${year}-${month}-${date} ${hour}:${minute}:${second}`;
                        
                        // 원본 데이터에 추가 정보 설정
                        dataArray3[x].checkState = checkState;
                        dataArray3[x].formattedDate = formattedDate;
                        
                        listData.push(dataArray3[x]);
                    }
                    
                    // ExcelJS 워크북 생성
                    var workbook = new ExcelJS.Workbook();
                    
                    // 부품코드별로 그룹화
                    let temp = _.groupBy(listData, 'partCode');
                    
                    // 각 부품코드별로 워크시트 생성
                    _.forEach(temp, (value, key) => {
                        var worksheet = workbook.addWorksheet(key);
                        
                        // 각 부품에 대한 상세 데이터 추가
                        _.forEach(value, (item) => {
                            // 검사 항목 정렬
                            item.listProductCSInpection = _.sortBy(item.listProductCSInpection, ['inspectionIndex', 'inspectionOffset']);
                            
                            // 엑셀 내용 생성
                            var contentArr = [];
                            
                            // 헤더 정보
                            contentArr.push(['검사일자', '검사라인', '검사자명', '검사대상', '부품코드', '부품품명', 'LOT No.', '결과']);
                            contentArr.push([item.formattedDate || item.updated, item.line, item.manager, item.category, item.partCode, item.partName, item.barcode, item.checkState]);
                            
                            // 검사항목 헤더
                            contentArr.push(['검사항목', '', '검사기준', '', '검사결과', '', '', '', '', '', '']);
                            contentArr.push(['분류', '항목', '규격', '측정기기', 'X1', 'X2', 'X3', 'X4', 'X5', '평균', '판정']);
                            
                            // 각 검사 항목 데이터 추가
                            _.forEach(item.listProductCSInpection, (item2) => {
                                let resultArr = [];
                                
                                // 검사 결과 값 추출
                                _.forEach(item2.listProductCSInpectionStandard, (item3, i) => {
                                    if (i < 5) {
                                        if (item2.listProductCSInpectionStandard[7] && item2.listProductCSInpectionStandard[7].min) {
                                            resultArr.push(item3.max);
                                        } else {
                                            resultArr.push(item3.min);
                                        }
                                    }
                                    if (i === 5) {
                                        if (item2.listProductCSInpectionStandard[7] && item2.listProductCSInpectionStandard[7].min) {
                                            resultArr.push(item3.max);
                                        } else {
                                            resultArr.push('');
                                        }
                                    }
                                    if (i === 6) {
                                        resultArr.push(item3.max);
                                    }
                                });
                                
                                // 행 데이터 구성
                                let rowArr = [
                                    item2.inspectionTarget,
                                    item2.inspectionName,
                                    item2.listProductCSInpectionStandard[0] ? item2.listProductCSInpectionStandard[0].name : '',
                                    item2.listProductCSInpectionStandard[0] ? item2.listProductCSInpectionStandard[0].result : '',
                                ];
                                rowArr = rowArr.concat(resultArr);
                                
                                contentArr.push(rowArr);
                            });
                            
                            // 워크시트에 행 추가
                            worksheet.addRows(contentArr);
                            worksheet.addRows([[]]);
                            worksheet.addRows([[]]);
                            worksheet.addRows([[]]);
                        });
                    });
                    
                    // 파일명에 현재 날짜 추가
                    let dateObj = new Date();
                    let year = dateObj.getFullYear();
                    let month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
                    let date = dateObj.getDate().toString().padStart(2, '0');
                    let dateStr = year + month + date;
                    
                    // 엑셀 파일 생성 및 다운로드
                    workbook.xlsx.writeBuffer().then(function(data) {
                        var blob = new Blob([data], {
                            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                        }),
                        filename = '필터성적서(테이블형)_' + dateStr + '.xlsx',
                        reader = new FileReader();

                        reader.readAsDataURL(blob);

                        // 파일 다운로드
                        reader.onload = function(event) {
                            let save = document.createElement("a");
                            save.href = event.target.result;
                            save.download = filename;
                            document.body.appendChild(save);
                            save.click();
                            document.body.removeChild(save);
                            window.URL.revokeObjectURL(save.href);                
                        };
                    });
                }
                this.flagSpinner = false;
            }).catch(error => {
                console.log(error);
                this.flagSpinner = false;
            });
        },
        
        processExcelData(data) {
            let listData = [];
            
            // 검사완료, 승인완료 정렬
            let tempArr1 = _.filter(data, {
                state: 'P'
            });
            tempArr1 = _.orderBy(tempArr1, ['updated'], ['desc']);
            let tempArr2 = _.filter(data, {
                state: 'R'
            });
            tempArr2 = _.orderBy(tempArr2, ['updated'], ['desc']);
            let sortedData = tempArr1.concat(tempArr2);
            
            // 각 항목에 대해 checkState 속성 추가
            _.forEach(sortedData, (item) => {
                let checkState = 'PASS';
                if (item.csTime === 'FAIL') {
                    checkState = 'FAIL';
                }
                
                item.checkState = checkState;
                listData.push(item);
            });
            
            return listData;
        },
        
        // 고급검색 모달 표시
        showAdvancedSearch() {
            this.advancedSearchVisible = true;
        },
        
        // 고정 토글
        togglePin() {
            this.isPinned = !this.isPinned;
            if (this.isPinned) {
                this.$message.success('검색 조건이 고정되었습니다');
            } else {
                this.$message.info('검색 조건 고정이 해제되었습니다');
            }
        },
        
        // 전체화면 토글
        toggleFullscreen() {
            // 모달의 width를 변경하여 확대/축소 효과
            const modal = document.querySelector('.ant-modal');
            if (modal) {
                if (modal.style.width === '90%') {
                    modal.style.width = '600px';
                } else {
                    modal.style.width = '90%';
                }
            }
        },
        
        // 부품명 조회 (Lookup)
        lookupPartName() {
            this.$message.info('부품명 조회 기능은 준비 중입니다');
            // TODO: 부품명 조회 API 연동
        },
        
        // 고급검색 실행
        executeAdvancedSearch() {
            let queryParams = [];
            let apiUrl = `${this.$store.state.nodeApiUrl}/product/cs/list_filter_advanced?state=P,R`;
            
            // 날짜 조건
            if (this.advSearch.useDate && this.advSearch.dateStart) {
                apiUrl += `&start_date=${this.advSearch.dateStart}`;
                queryParams.push(`검사일자: ${this.advSearch.dateStart}`);
            }
            if (this.advSearch.useDate && this.advSearch.dateEnd) {
                apiUrl += `&end_date=${this.advSearch.dateEnd}`;
                queryParams.push(`~ ${this.advSearch.dateEnd}`);
            }
            
            // 검사라인 조건
            if (this.advSearch.useLine && this.advSearch.line) {
                apiUrl += `&line=${encodeURIComponent(this.advSearch.line)}`;
                queryParams.push(`검사라인: ${this.advSearch.line}`);
            }
            
            // LOT 조건
            if (this.advSearch.useLotNo && this.advSearch.lotNo) {
                apiUrl += `&lotNo=${encodeURIComponent(this.advSearch.lotNo)}`;
                queryParams.push(`Lot No.: ${this.advSearch.lotNo}`);
            }
            
            // 검사자 조건
            if (this.advSearch.useManager && this.advSearch.manager) {
                apiUrl += `&manager=${encodeURIComponent(this.advSearch.manager)}`;
                queryParams.push(`검사자: ${this.advSearch.manager}`);
            }
            
            // 검사대상 조건
            if (this.advSearch.category) {
                apiUrl += `&category=${encodeURIComponent(this.advSearch.category)}`;
                queryParams.push(`검사대상: ${this.advSearch.category}`);
            }
            
            // 부품코드 조건
            if (this.advSearch.usePartCode && this.advSearch.partCode) {
                apiUrl += `&part_code=${this.advSearch.partCode}`;
                queryParams.push(`부품코드: ${this.advSearch.partCode}`);
            }
            
            // 부품명 조건
            if (this.advSearch.partName) {
                apiUrl += `&part_name=${encodeURIComponent(this.advSearch.partName)}`;
                queryParams.push(`부품명: ${this.advSearch.partName}`);
            }
            
            // 외관 조건
            if (this.advSearch.appearance) {
                apiUrl += `&appearance=${this.advSearch.appearance}`;
                queryParams.push(`외관: ${this.advSearch.appearance}`);
            }
            
            // 성능 조건
            if (this.advSearch.performance) {
                apiUrl += `&performance=${this.advSearch.performance}`;
                queryParams.push(`성능: ${this.advSearch.performance}`);
            }
            
            // 무게 조건
            if (this.advSearch.weight) {
                apiUrl += `&weight=${this.advSearch.weight}&weightOperator=${this.advSearch.weightOperator}`;
                queryParams.push(`무게: ${this.advSearch.weightOperator} ${this.advSearch.weight}`);
            }
            
            // 치수 조건
            const dimensions = ['A', 'B', 'C', 'D', 'E'];
            dimensions.forEach(dim => {
                const value = this.advSearch[`dim${dim}`];
                const operator = this.advSearch[`dim${dim}Operator`];
                if (value) {
                    apiUrl += `&dim${dim}=${value}&dim${dim}Operator=${operator}`;
                    queryParams.push(`치수${dim}: ${operator} ${value}`);
                }
            });
            
            // 검색 조건 확인
            if (queryParams.length === 0) {
                this.$message.warning('검색 조건을 선택해주세요');
                return;
            }
            
            // API 호출 (base URL 저장, size/page는 별도 관리)
            this.advancedSearchBaseUrl = apiUrl;
            const pagedUrl = apiUrl + `&size=${this.pagination.pageSize}&page=0`;
            this.flagSpinner = true;
            this.$http.get(pagedUrl)
                .then((response) => {
                    if (response.status === 200 && response.data.code === 'success') {
                        this.pagination.total = response.data.data.totalElements || 0;
                        this.pagination.current = 1;
                        this.advancedSearchMode = true;

                        this.dataArray3 = response.data.data.content;
                        this.data3 = this.dataArray3.map((item, index) => {
                            let tag = item.state === 'P' ? '검사완료' : '승인완료';
                            let checkState = item.csTime === 'FAIL' ? 'FAIL' : 'PASS';

                            let updatedObj = new Date(item.updated);
                            let year = updatedObj.getFullYear();
                            let month = (updatedObj.getMonth() + 1).toString().padStart(2, '0');
                            let date = updatedObj.getDate().toString().padStart(2, '0');
                            let hour = updatedObj.getHours().toString().padStart(2, '0');
                            let minute = updatedObj.getMinutes().toString().padStart(2, '0');
                            let second = updatedObj.getSeconds().toString().padStart(2, '0');

                            return {
                                key: index,
                                productCsSeq: item.productCsSeq,
                                tags: [tag],
                                model: item.productModel || '-',
                                modelDetail: item.productModelDetail || '-',
                                product: item.productName || '-',
                                pop: item.productPop || '-',
                                line: item.line || '-',
                                barcode: item.barcode || '-',
                                manager: item.manager || '-',
                                checkState: checkState,
                                category: item.category || '-',
                                partCode: item.partCode || '-',
                                partName: item.partName || '-',
                                updated: `${year}-${month}-${date} ${hour}:${minute}:${second}`,
                            };
                        });
                        
                        // 모달 닫기 (고정되지 않은 경우)
                        if (!this.isPinned) {
                            this.advancedSearchVisible = false;
                        }
                        
                        this.$message.success(`고급검색 완료: ${this.pagination.total}개 결과`);
                    }
                    this.flagSpinner = false;
                })
                .catch((error) => {
                    console.error(error);
                    this.$message.error('고급검색에 실패했습니다.');
                    this.flagSpinner = false;
                });
        }
    }
}
</script>
<style scoped>
</style>